/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable */
export const genericProductPaginationContainer = () => ({
    keyArgs: ['id', 'term', 'zipCode', 'locationType', 'pageSize', 'page', 'productOptions', ['facets']],
    merge(existing, incoming, { args: { productOptions: { page } = {} } }) {
        if (!existing || page === 1) {
            // if page is one discard the previously cached data for the query so the new data is not appended to stale data
            return incoming;
        }
        return {
            ...existing,
            products: [
                ...existing.products,
                ...incoming.products,
            ],
            /* eslint-disable-next-line no-underscore-dangle */
            __typename: incoming?.__typename,
        };
    },
});

export default {};
